import React, { createContext, useContext, useEffect, useState } from "react";
import { custApi, CUST_TOKEN_KEY, CUST_USER_KEY } from "./customerApi";

const CustAuthCtx = createContext(null);

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem(CUST_USER_KEY);
    const token = localStorage.getItem(CUST_TOKEN_KEY);
    if (raw && token) {
      try { setCustomer(JSON.parse(raw)); } catch { /* ignore */ }
    }
    setReady(true);
  }, []);

  const _finalize = (data) => {
    localStorage.setItem(CUST_TOKEN_KEY, data.token);
    localStorage.setItem(CUST_USER_KEY, JSON.stringify(data.customer));
    setCustomer(data.customer);
    return data;
  };

  // Iter 138 — kept as `login` for backwards compat but also exposed
  // as `loginOtp`. New primary flow is `loginPin`.
  const loginOtp = async (phone, otp) => {
    const r = await custApi.post("/public/customer/login/verify", { phone, otp });
    return _finalize(r.data);
  };
  const loginPin = async (phone, pin) => {
    const r = await custApi.post("/public/customer/login/pin", { phone, pin });
    return _finalize(r.data);
  };
  const login = loginOtp;

  const logout = () => {
    localStorage.removeItem(CUST_TOKEN_KEY);
    localStorage.removeItem(CUST_USER_KEY);
    setCustomer(null);
  };

  return (
    <CustAuthCtx.Provider value={{ customer, login, loginOtp, loginPin, logout, ready }}>
      {children}
    </CustAuthCtx.Provider>
  );
}

export function useCustAuth() {
  const ctx = useContext(CustAuthCtx);
  if (!ctx) throw new Error("useCustAuth must be used inside CustomerAuthProvider");
  return ctx;
}
